import AppsIcon from '../icons/AppsIcon';
import FinanceIcon from '../icons/FinanceIcon';
import AdIcon from '../icons/AdIcon';
import SettingsIcon from '../icons/SettingsIcon';
import SupportIcon from '../icons/SupportIcon';

const newAdsItems = [
  {
    route: 'advertisement-create-campaign',
    title: 'ADVERTISEMENT.CAMPAIGNS.CREATE_CAMPAIGN',
  },
  {
    route: 'advertisement-manage-campaigns',
    title: 'ADVERTISEMENT.MANAGE_CAMPAIGNS.TITLE',
  },
  {
    route: 'advertisement-reporting',
    title: 'ADVERTISEMENT.REPORTING.TITLE',
  },
];

const oldAdsLinks = [
  {
    route: 'advertisement-campaigns',
    title: 'ADVERTISEMENT.CAMPAIGNS.TITLE',
  },
];

export default ({
  isForeigner,
  isMembershipExpired,
  contractIsNotAccepted,
  shebaIsNotVerified,
  isAdsTester,
  hasSupport,
  showAds
}) => ({
  key: 'main-sidebar',
  items: [
    {
      route: 'apps',
      title: 'APPLICATIONS',
      icon: AppsIcon,
    },
    {
      route: 'finance',
      title: 'FINANCE',
      auth: ['publisher', 'blockedPublisher', 'viewFinanceInfo'],
      icon: FinanceIcon,
      children: [
        {
          route: 'settlement',
          title: 'FINANCE.SETTLEMENT.TITLE',
          warnBadge: shebaIsNotVerified,
        },
        {
          route: 'sales-invoice',
          title: 'FINANCE.SALES_INVOICE.TITLE',
        },
        {
          route: 'sales-chart',
          title: 'FINANCE.SALES_CHART.TITLE',
        },
      ],
    },
    {
      route: 'advertisement',
      title: 'ADVERTISEMENT.TITLE',
      auth: ['advertisement'],
      icon: AdIcon,
      disabled: !showAds,
      children: [
        ...(isAdsTester ? newAdsItems : oldAdsLinks),
        {
          route: 'advertisement-finance',
          title: 'ADVERTISEMENT.WALLET',
        },
        {
          route: 'advertisement-keyword-planner',
          title: 'ADVERTISEMENT.KEYWORDPLANNER.TITLE',
        },
        {
          route: 'advertisement-mail-service',
          title: 'ADVERTISEMENT.MAIL_SERVICE',
        },
      ],
    },
    {
      route: 'settings',
      title: 'SETTINGS',
      icon: SettingsIcon,
      auth: [
        'publisher',
        'viewFinanceInfo',
        'changeFinanceInfo',
        'development',
        'agent',
      ],
      children: [
        {
          route: 'account-status',
          title: 'ACCOUNT.STATUS.TITLE',
          auth: ['publisher', 'changePublicInfo'],
          enabled: !isForeigner,
          warnBadge: isMembershipExpired,
        },
        {
          route: 'publisher',
          title: 'PUBLISHER_ACCOUNT.TITLE',
          auth: ['publisher', 'changePublicInfo'],
        },
        {
          route: 'contract',
          title: 'CONTRACT.TITLE',
          auth: ['publisher', 'changePublicInfo'],
          warnBadge: contractIsNotAccepted,
        },
        { route: 'agents', title: 'AGENTS.TITLE', auth: ['publisher'] },
        {
          route: 'developers-titles',
          title: 'DEVELOPER_TITLES.TITLE',
          auth: ['publisher', 'changePublicInfo'],
        },
        {
          route: 'agent-information',
          title: 'SETTINGS.AGENT_INFORMATION.TITLE',
          auth: ['agent'],
        },
        {
          route: 'change-password',
          title: 'SETTINGS.CHANGE_PASSWORD.TITLE',
          auth: ['publisher', 'blockedPublisher', 'developersApi', 'agent'],
        },
        {
          route: 'two-step-verification',
          title: 'SETTINGS.TWO_STEP_VERIFICATION.TITLE',
          auth: ['publisher', 'blockedPublisher', 'agent'],
        },
        {
          route: 'developers-api',
          title: 'SETTINGS.DEVELOPERS_API.TITLE',
          auth: ['publisher', 'blockedPublisher', 'developersApi'],
        },
      ],
    },
    {
      route: 'support',
      title: 'SUPPORT_AND_EDUCATION',
      icon: SupportIcon,
      children: [
        {
          link: 'https://ads.cafebazaar.ir/academy',
          title: 'ADS_ACADEMY',
          newBadge: true,
        },
        {
          route: 'faq',
          title: 'SUPPORT.FAQ',
          enabled:hasSupport,
        },
        {
          route: 'tickets',
          title: 'SUPPORT.SUPPORT_TICKETS',
          enabled: hasSupport,
        },
        {
          route: 'contact-us',
          title: 'SUPPORT.CONTACT_US',
        }      
      ],
    },
  ],
});
